<template>
  <b-modal
    :title="getTitle"
    v-model="showModal"
    no-close-on-backdrop
    centered
    hide-footer
    size="xl"
  >
    <div class="row scroll">
      <div class="col-12">
        <h5 class="text-primary">
          Este expediente ha sido creado por {{ file.solicitanteNombre }}
          <small>{{ file.solicitanteEmail }}</small>
          <span v-if="file.solicitanteGrupoNombre">
            , perteneciente a la unidad {{file.solicitanteGrupoNombre}}
          </span>
        </h5>
      </div>
      <div class="col-12" style="margin: 0 auto;">
        <div class="row">
          <div class="shadow col-4">
            <vs-list>
              <vs-list-item
                v-if="isConvention"
                icon="tag"
                :title="file.numero || '-'" subtitle="Número de documento"
              />
              <vs-list-item
                icon="description"
                :title="file.emisorCentroCostoNombre || '-'" subtitle="Tipo de documento"
              />
              <vs-list-item
                v-if="file.emisorSucursalDireccion
                && (!isUseExternalForm || file.claseMercadoPublico === 'numOf')"
                icon="description"
                :title="file.emisorSucursalDireccion || '-'" subtitle="Documento"
              />
              <vs-list-item
                v-if="file.numeroInt"
                icon="tag"
                :title="file.numeroInt || '-'" subtitle="Nº Documento"
              />
              <vs-list-item
                v-if="file.fechaEmision
                && (file.claseMercadoPublico === 'int' || file.claseMercadoPublico === 'ext')"
                icon="date_range"
                :title="file.fechaEmision | dateFormat" subtitle="Fecha Documento"
              />
              <vs-list-item
                v-if="(file.claseMercadoPublico === 'numInt'
                 || file.claseMercadoPublico === 'numOf')
                  && file.condicionDespacho === '0'
                  && (!isUseExternalForm || file.claseMercadoPublico === 'numOf')"
                icon="description"
                :title="'Papel' || '-'" subtitle="Formato"
              />
              <vs-list-item
                v-if="(file.claseMercadoPublico === 'numInt'
                 || file.claseMercadoPublico === 'numOf')
                  && file.condicionDespacho === '1'
                   && (!isUseExternalForm || file.claseMercadoPublico === 'numOf')"
                icon="description"
                :title="'Electrónico' || '-'" subtitle="Formato"
              />
              <vs-list-item
                v-if="file.claseMercadoPublico === 'ext'"
                icon="description"
                title="Externo" subtitle="Tipo Expediente"
              />
              <vs-list-item
                v-if="file.claseMercadoPublico === 'int'"
                icon="description"
                title="Interno" subtitle="Tipo Expediente"
              />
              <vs-list-item
                v-if="file.transportePuertoTipo === '0'"
                icon="description"
                title="No"
                subtitle="Es privado"
              />
              <vs-list-item
                v-if="file.transportePuertoTipo === '1'"
                icon="description"
                title="Si"
                subtitle="Es privado"
              />
              <vs-list-item
                v-if="file.transportePuertoTipo === '2'"
                icon="description"
                title="Si"
                subtitle="Es Reservado"
              />
              <vs-list-item
                v-if="isAguasAndinas && getMetadataValue('DOCNUM')"
                icon="description"
                :title="getMetadataValue('DOCNUM')"
                subtitle="Número interno Librería"
              />
            </vs-list>
          </div>
          <div class="shadow col-4">
            <vs-list>
              <vs-list-item
                v-if="isAguasAndinas && getMetadataValue('ID_TEMA')"
                icon="description"
                :title="getMetadataValue('ID_TEMA')"
                subtitle="Tema"
              />
              <vs-list-item
                v-if="isAguasAndinas && getMetadataValue('ID_SUBTEMA')"
                icon="description"
                :title="getMetadataValue('ID_SUBTEMA')"
                subtitle="Subtema"
              />
              <vs-list-item
                v-if="file.compradorArea && !haveSISSConfig"
                icon="account_balance"
                :title="file.compradorArea || '-'" subtitle="Tipo institución remitente"
              />
              <vs-list-item
                v-if="file.compradorCodigo && isUseExternalForm && haveSISSConfig"
                icon="account_balance"
                :title="file.compradorCodigo || '-'" subtitle="Remitente"
              />
              <vs-list-item
                v-if="file.emisorContactoArea
                 && (file.compradorArea === 'PJU' || file.compradorArea === 'OES'
                  || file.compradorArea === 'PROV'|| file.compradorArea === 'SAN')"
                icon="account_balance"
                :title="file.emisorContactoArea || '-'" subtitle="Institución remitente"
              />
              <vs-list-item
                icon="account_circle"
                :title="file.emisorContactoNombre || '-'" subtitle="Persona remitente"
              />
              <vs-list-item
                icon="assignment_ind"
                v-if="!isUseExternalForm && file.claseMercadoPublico !== 'ext'"
                :title="file.emisorContactoCargo || '-'" subtitle="Cargo persona remitente"
              />
              <vs-list-item
                v-if="file.emisorContactoEmail"
                icon="mail"
                :title="file.emisorContactoEmail || '-'" subtitle="Correo persona remitente"
              />
              <vs-list-item
                v-if="file.emisorContactoTelefono"
                icon="assignment_ind"
                :title="file.emisorContactoTelefono || '-'" subtitle="Teléfono persona remitente"
              />
              <vs-list-item
                v-if="file.plazo > 0 "
                icon="thumb_up"
                :title="file.plazo || '-'" subtitle="Adhesión"
              />
              <vs-list-item
                v-if="file.transporteNotas &&
                 (!isUseExternalForm || file.claseMercadoPublico === 'numOf')
"
                icon="subject"
                :title="file.transporteNotas || '-'"
                subtitle="Detalle"
              />
              <vs-list-item
                v-if="file.transporteNotas && isUseExternalForm"
                icon="room"
                :title="file.transporteNotas || '-'"
                subtitle="Oficina de partes destino"
              />
              <vs-list-item
                v-if="file.transporteViaTransporteCodigoTransporte && isUseExternalForm"
                icon="subject"
                :title="file.transporteViaTransporteCodigoTransporte || '-'"
                subtitle="Link carpeta compartida"
              />
              <vs-list-item
                v-if="file.compradorTelefono && isUseExternalForm"
                icon="subject"
                :title="file.compradorTelefono || '-'"
                subtitle="Número SAC"
              />
              <vs-list-item
                v-if="file.compradorEmail && isUseExternalForm"
                icon="subject"
                :title="file.compradorEmail || '-'"
                subtitle="Número oficio"
              />
              <vs-list-item
                v-if="file.compradorCargo && isUseExternalForm"
                icon="subject"
                :title="file.compradorCargo || '-'"
                subtitle="Id Adquisiciones"
              />
            </vs-list>
          </div>
          <ConventionAuthors v-if="authors" />
          <ConventionParticipants v-if="participants" />
          <div v-if="isConvention" class="col-md-4 shadow">
            <vs-list>
              <vs-list-item
                v-if="detailsFile.dnt && detailsFile.dnt.titulo"
                icon="subject"
                :title="detailsFile.dnt.titulo"
                subtitle="Nombre del expediente"
              />
              <vs-list-item
                v-if="detailsFile.dnt &&
                  detailsFile.dnt.transporteViaTransporteVehiculoPatente"
                icon="subject"
                :title="getProposalStatus"
                subtitle="Estado de la propuesta"
              />
            </vs-list>
          </div>
          <div v-if="!isConvention" class="col-md-4 shadow">
            <vs-list>
              <vs-list-item
                v-if="file.transporteViaTransporteCodigoTransporte === '1'
                && (!isUseExternalForm || file.claseMercadoPublico === 'numOf')"
                icon="description"
                title="Si"
                subtitle="Acompaña físico"
              />
              <vs-list-item
                v-if="file.transporteViaTransporteCodigoTransporte === '0'
                && (!isUseExternalForm || file.claseMercadoPublico === 'numOf')"
                icon="description"
                title="No"
                subtitle="Acompaña físico"
              />
              <vs-list-item
                v-if="file.transportePuertoCodigo && isUseExternalForm && haveSISSConfig"
                icon="description"
                :title="file.transportePuertoCodigo"
                subtitle="Código Rif"
              />
              <vs-list-item
                v-if="file.emisorContactoCodigo && isUseExternalForm && isFormInt"
                icon="description"
                :title="file.emisorContactoCodigo"
                subtitle="Código documento"
              />
              <vs-list-item
                v-if="(file.claseMercadoPublico === 'numInt'
                 || file.claseMercadoPublico === 'numOf')
                  && file.condicionDespacho === '1' && isUseExternalForm"
                icon="description"
                :title="file.condicionDespacho || '-'" subtitle="Nº expediente"
              />
              <vs-list-item
                v-if="file.transportePuertoNombre && isUseExternalForm"
                icon="description"
                :title="file.transportePuertoNombre || '-'" subtitle="Proceso"
              />
              <vs-list-item
                v-if="file.transportePuertoPais && isUseExternalForm"
                icon="description"
                :title="file.transportePuertoPais || '-'" subtitle="SubProceso"
              />
              <vs-list-item
                v-if="detailsFile.observaciones && detailsFile.observaciones.length === 2 &&
                !isAguasAndinas"
                icon="subject"
                :title="getObservation(detailsFile.observaciones)"
                subtitle="Observación"
              />
              <vs-list-item
                v-if="detailsFile.observaciones && detailsFile.observaciones.length === 2 &&
                isAguasAndinas"
                icon="subject"
                subtitle="Observación"
              />
              <div
                class="scrollMateria"
                v-if="detailsFile.observaciones && detailsFile.observaciones.length === 2 &&
                isAguasAndinas"
              >
                {{getObservation(detailsFile.observaciones)}}
              </div>
              <vs-list-item
                v-if="detailsFile.observaciones &&
                detailsFile.observaciones.length >= 1 &&
                !isAguasAndinas"
                icon="subject"
                :title="getMatter(detailsFile.observaciones)"
                subtitle="Materia"
              />
              <vs-list-item
                v-if="detailsFile.observaciones &&
                detailsFile.observaciones.length >= 1 &&
                isAguasAndinas"
                icon="subject"
                subtitle="Materia"
              />
              <div
                class="scrollMateria"
                v-if="detailsFile.observaciones &&
                detailsFile.observaciones.length >= 1 &&
                isAguasAndinas"
              >
                {{getMatter(detailsFile.observaciones)}}
              </div>
              <div class="mt-3" v-if="!isUseExternalForm">
                <h5>Etiquetas</h5>
                <div v-for="tag in detailsFile.etiquetas" :key="tag.dnt_etiqueta_id">
                  <vs-chip>
                    {{tag.etiqueta}}
                  </vs-chip>
                </div>
              </div>
            </vs-list>
          </div>
        </div>
        <div class="row" v-if="file.emisorInfoAdicional">
          <div class="shadow col-12">
            <vs-list>
              <div class="vs-list--item">
                <div class="vs-list--icon">
                  <i class="vs-icon notranslate icon-scale material-icons">
                    description
                  </i>
                </div>
                <div class="list-titles">
                  <div class="vs-list--title">
                    <a
                      :href="file.emisorInfoAdicional"
                      target="_blank"
                    >
                      {{file.emisorInfoAdicional}}
                    </a>
                  </div>
                  <div class="vs-list--subtitle">
                    URL Carpeta compartida
                  </div>
                </div>
              </div>
            </vs-list>
          </div>
        </div>
      </div>
      <div
        v-if="!loadingDocs && isConvention"
        class="col-md-12 mt-5 shadow" style="margin: 0 auto;"
      >
        <div class="row">
          <div class="col-6 mt-5">
            <h5>
              Metadata
            </h5>
            <div v-if="getTitleMetadata">
              <b>Título</b>
              <div>
                {{getTitleMetadata}}
              </div>
            </div>
            <div v-if="getAlternativeTitleMetadata">
              <b>Título alternativo</b>
              <div>
                {{getAlternativeTitleMetadata}}
              </div>
            </div>
          </div>
          <div class="col-6 mt-5">
            <h5>
              Metadata
            </h5>
            <div v-if="getKeyboardsMetadata && getKeyboardsMetadata.length">
              <b>Palabras Clave</b>
              <div v-for="keyword in getKeyboardsMetadata" :key="keyword.id">
                - {{keyword.label}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <vs-divider />
      <div class="col-12" v-if="loadingDocs">
        <div class="row px-5">
          <h5 class="mb-0 ml-5">Adjuntar archivos:</h5>
          <load-files-new
            :values="attachments || []"
            class="col-12"
            withTrueCopy
            ref="attachedFiles"
          />
          <small class="text-danger ml-5 pl-5" v-if="error.isPdf">{{error.isPdf}}</small>
          <small class="text-danger ml-5 pl-5" v-if="error.noMainFile">{{error.noMainFile}}</small>
          <div class="col-12 mt-5 text-center">
            <vs-button
            data-cy="save"
              v-tooltip="''"
              class="mr-2 btn btn-success"
              @click="save"
              :disabled="loading"
            >
              {{loading ? 'Guardando...' : 'Guardar'}}
            </vs-button>
          </div>
        </div>
      </div>
      <div v-if="!loadingDocs" class="col-md-6 mt-5 shadow" style="margin: 0 auto;">
        <div class="mt-5">
          <div class="d-flex align-items-center justify-content-between">
            <h5 class="mb-0">
              Destinos / Copias
            </h5>
            <div v-if="hasInactiveSubjects" class="d-flex align-items-center">
              <small class="mr-2">Ver inactivos</small>
              <vs-switch v-model="showInactiveSubjects" data-cy="toggle-inactive-subjects" />
            </div>
          </div>
          <vs-table
            class="wrap-table-large mt-3"
            stripe
            :data="(visibleSubjects || [])"
            noDataText="No hay destinatarios"
          >
            <template slot="header">
            </template>
            <template slot="thead">
              <vs-th>
                Nombre
              </vs-th>
              <vs-th>
                Tipo
              </vs-th>
              <vs-th>
                Alcance
              </vs-th>
            </template>
            <template>
              <tbody>
              <vs-tr
                v-for="(subject, index) in visibleSubjects"
                :key="index"
                :class="{ 'subject-inactive': subject.estado == 2 }"
              >
                <vs-td data-cy="suject">
                  {{subject.destinoListaNombre}}
                  <small
                    class="d-block"
                    v-if="externalSubject.includes(subject.destinoCodigo)"
                    data-cy='subject-email'
                  >
                    {{subject.destinoCorreo}}
                  </small>
                  <small
                    class="d-block"
                    v-if="subject.institucionNombre"
                    data-cy='subject-institution-name'
                  >
                    {{subject.institucionNombre}}
                  </small>
                  <small class="d-block">
                    <span
                      data-cy='subject-email'
                      v-if="!externalSubject.includes(subject.destinoCodigo)"
                    >
                      {{subject.destinoCorreo}}
                    </span>
                    <b-badge
                      style="cursor:pointer;"
                      v-if="internalSubject.includes(subject.destinoCodigo)"
                      variant="light-primary"
                      pill
                      data-cy="see-distribution"
                      @click="findEmails(subject)"
                    >
                      ver distribución
                    </b-badge>
                  </small>
                </vs-td>
                <vs-td data-cy='subject-type'>
                  <span v-if="isAguasAndinas && subject.destinoNombre === 'Funcionarios'">
                    Usuarios
                  </span>
                  <span v-if="isAguasAndinas && subject.destinoNombre !== 'Funcionarios'">
                    {{subject.destinoNombre}}
                  </span>
                  <span v-if="!isAguasAndinas">
                    {{subject.destinoNombre}}
                  </span>
                  <small class="d-block" v-if="subject.providenciaId">
                    <b>providencia</b>
                  </small>
                </vs-td>
                <vs-td class="text-center">
                  <div>
                    <b-badge
                      variant="primary"
                      v-if="subject.tipoDestino === '1'"
                    >
                      Destinatario
                    </b-badge>
                    <b-badge
                      variant="info"
                      v-if="subject.tipoDestino === '2'"
                    >
                      En copia
                    </b-badge>
                  </div>
                  <div class="d-block" v-if="subject.providenciaId">
                    <small>
                      {{providencesMap[subject.providenciaId]}}
                      <b v-if="subject.providenciaVencimiento">
                        - {{subject.providenciaVencimiento | dateFormat}}
                      </b>
                    </small>
                  </div>
                </vs-td>
              </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>
        <div v-if="!loadingDocs" class=" mt-5 mb-5">
          <h5>
            Comentarios
          </h5>
          <vs-table
            class="wrap-table"
            stripe
            :data="(orderCommentsEd || [])"
            noDataText="No hay comentarios"
          >
            <template slot="thead">
              <vs-th>
                Nombre
              </vs-th>
              <vs-th>
                Fecha
              </vs-th>
              <vs-th>
                Comentario
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  {{ data[indextr].usuarioComentario }}
                </vs-td>
                <vs-td>
                  {{ data[indextr].fechaCreacion | dateFormatTime }}
                </vs-td>
                <vs-td>
                  {{ data[indextr].comentario }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
      <div v-if="!loadingDocs" class="col-md-6 mt-5 shadow" style="margin: 0 auto;">
        <div class=" mt-5">
          <h5>
            Archivos adjuntos
          </h5>
          <vs-table
            stripe
            :data="(detailsFile.adjuntos || [])"
            noDataText="No hay archivos adjuntos"
          >
            <template slot="header">
            </template>
            <template slot="thead">
              <vs-th v-if="isConvention">
                Nombre documento
              </vs-th>
              <vs-th>
                Nombre Adjunto
              </vs-th>
              <vs-th>
                Tipo
              </vs-th>
              <vs-th>
                Formato
              </vs-th>
              <vs-th>
                Ver
              </vs-th>
            </template>
            <template>
              <tbody>
              <vs-tr
                v-for="attachment in attachments"
                :key="attachment.adjuntoId"
              >
                <vs-td v-if="isConvention">
                  {{ attachment.tipoDescripcion }}
                </vs-td>
                <vs-td>
                  {{ attachment.adjuntoNombre }}
                </vs-td>
                <vs-td>
                  {{attachment.tipo}}
                </vs-td>
                <vs-td>
                  {{attachment.otraReferenciaId}}
                </vs-td>
                <vs-td>
                  <DownloadFile
                    :mood="'compact'"
                    v-if="attachment && attachment.adjuntoNombre && attachment.adjuntoUrl"
                    :path="attachment.adjuntoUrl"
                    :name="attachment.adjuntoNombre"
                    class="pill-info-attach"
                  />
                </vs-td>
              </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>
        <div v-if="!loadingDocs" class=" mt-5 mb-5">
          <h5>
            Referencias
          </h5>
          <vs-table
            class="wrap-table"
            stripe
            :data="(detailsFile.referencias || [])"
            noDataText="No hay otros documentos relacionados"
          >
            <template slot="header">
            </template>
            <template slot="thead">
              <vs-th>
                Tipo Documento
              </vs-th>
              <vs-th>
                Número
              </vs-th>
            </template>

            <template>
              <tbody v-if="!isUseExternalForm">
              <vs-tr v-if="file.transportePuertoCodigo && !isUseExternalForm">
                <vs-td>
                  Contrato SAFI
                </vs-td>
                <vs-td>
                  {{file.transportePuertoCodigo}}
                </vs-td>
              </vs-tr>
              <vs-tr
                v-for="reference in (detailsFile.referencias || [])"
                :key="reference.dntReferenciaId"
              >
                <vs-td>
                  <span v-if="reference.documentoId">
                    {{ findTypeDocument(reference.tipoDocumento) }}
                    </span>
                  <span v-if="!reference.documentoId">
                    {{ findLabelDocument(reference.tipoDocumento) }}
                  </span>
                </vs-td>
                <vs-td>
                  {{reference.folio}}
                </vs-td>
              </vs-tr>
              </tbody>
              <tbody v-if="isUseExternalForm">
              <vs-tr
                v-for="reference in (detailsFile.referencias || [])"
                :key="reference.dntReferenciaId"
              >
                <vs-td>
                  <span v-if="reference.documentoId">
                    {{ findTypeDocument(reference.tipoDocumento) }}
                    </span>
                  <span v-if="!reference.documentoId">
                    {{ findLabelDocument(reference.tipoDocumento) }}
                  </span>
                </vs-td>
                <vs-td>
                  {{reference.folio}}
                </vs-td>
              </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
    <b-modal
      ref="emailsGroup"
      id="emailsGroup"
      title="Distribución dentro del grupo"
      hide-footer
    >
      <b-overlay :show="loadingUsers">
        <vs-list v-if="usersGroup.length">
          <vs-list-item
            v-for="user in usersGroup"
            :key="user.id"
            icon="person"
            :title="user.nombre" :subtitle="user.correo"
          />
        </vs-list>
        <div v-if="!usersGroup.length">
          <h5>No hay usuarios para distribuir</h5>
        </div>
      </b-overlay>
    </b-modal>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ConventionAuthors from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/ConventionAuthors';
import ConventionParticipants from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/ConventionParticipants';
import FindTypeDocumentMixin from '@/febos/chile/dnt/mixins/FindTypeDocumentMixin';
import DownloadFile from '@/febos/chile/dnt/components/DownloadFile';
import ProvidencesMap from '@/febos/chile/dnt/mixins/ProvidencesMap';
import FindLabelDocumentMixin from '@/febos/chile/dnt/mixins/FindLabelDocumentMixin';
import { getUsersByGroup } from '@/febos/servicios/api/empresas.api';
import LoadFilesNew from '@/febos/chile/dnt/components/LoadFilesNew';
import { GORE_VALPARAISO, SERCOTEC, SISS } from '@/constants/companies';

export default {
  name: 'PopUpDetailFile',
  components: {
    DownloadFile,
    ConventionAuthors,
    ConventionParticipants,
    LoadFilesNew
  },
  mixins: [FindTypeDocumentMixin, FindLabelDocumentMixin],
  props: {
    file: {
      type: Object,
      required: true,
      default: () => {}
    },
    fetchDocuments: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      providencesMap: ProvidencesMap,
      tags: [],
      externalSubject: [
        'empresas',
        'personas',
        'ministerios',
        'sanitarias'
      ],
      internalSubject: [
        'unidades',
        'oficinas',
        'comisiones'
      ],
      usersGroup: [],
      loadingUsers: false,
      showInactiveSubjects: false,
      mainFile: {},
      additionalFiles: [],
      titleMetadata: '',
      isPartOf: '',
      keywords: [],
      clasification: '',
      notes: [],
      relations: [],
      error: {
        isPdf: '',
        noMainFile: ''
      }
    };
  },
  computed: {
    ...mapGetters('Dnts', [
      'loading',
      'successAction',
      'detailsFile',
      'attachmentsFile',
      'fileCommentDetails',
      'loadingDocs',
      'commentsEd'
    ]),
    ...mapGetters('List', [
      'allDocumentsState'
    ]),
    ...mapGetters('Modals', ['modalName']),
    ...mapGetters('Empresas', ['company']),
    isUseExternalForm() {
      return [GORE_VALPARAISO.iut, SISS.iut, SERCOTEC.iut].includes(this.company.iut);
    },
    subjects() {
      return (this.detailsFile.destinatarios || [])
        .sort(({ tipoDestino: a }, { tipoDestino: b }) => a.localeCompare(b));
    },
    hasInactiveSubjects() {
      return this.subjects.some((subject) => subject.estado == 2);
    },
    visibleSubjects() {
      if (this.showInactiveSubjects) return this.subjects;
      return this.subjects.filter((subject) => subject.estado != 2);
    },
    isConvention() {
      return this.company.iut === '60100003-2';
    },
    isSiss() {
      return this.company.iut === '61221000-4';
    },
    isFormInt() {
      return this.file.claseMercadoPublico === 'int';
    },
    haveSISSConfig() {
      const configuredForms = ['int', 'ext', 'numOf'];
      return configuredForms.includes(this.file.claseMercadoPublico);
    },
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    },
    attachments() {
      if (!this.detailsFile.adjuntos) return [];
      const attachments = [...this.detailsFile.adjuntos];
      return attachments.sort(({ tipo: a }, { tipo: b }) => b.localeCompare(a));
    },
    getTitle() {
      return `Detalles del Expediente ${this.file.numero}`;
    },
    getProposalStatus() {
      const proposalStatus = {
        approved: 'Aprobada',
        'partial-approved': 'Aprobada parcial',
        rejected: 'Rechazada',
        retired: 'Retirada',
        'not-processed': 'No tramitada',
        inadmissible: 'Inadmisible'
      };
      return proposalStatus[this.detailsFile.dnt.transporteViaTransporteVehiculoPatente];
    },
    getTitleMetadata() {
      const { metadata } = this.detailsFile;
      if (metadata && metadata.length) {
        const title = metadata.find((field) => field.nombre === 'title');
        return title ? title.valor : '';
      }
      return '';
    },
    getAlternativeTitleMetadata() {
      const { metadata } = this.detailsFile;
      if (metadata && metadata.length) {
        const title = metadata.find((field) => field.nombre === 'dc.title.alternative');
        return title ? title.valor : '';
      }
      return '';
    },
    getMetadataValue() {
      return (name) => {
        const { metadata } = this.detailsFile;
        if (metadata && metadata.length) {
          const title = metadata.find((field) => field.nombre === name);
          if (title) {
            return title.valor.includes('_') ? title.valor.replaceAll('_', ' ') : title.valor;
          }
          return '';
        }
        return '';
      };
    },
    getKeyboardsMetadata() {
      const { metadata } = this.detailsFile;
      if (metadata && metadata.length) {
        const keywords = metadata.find((field) => field.nombre === 'keywords') || [];
        return Object.keys(keywords).length ? JSON.parse(keywords.valor) : [];
      }
      return [];
    },
    orderCommentsEd() {
      // eslint-disable-next-line
      return this.commentsEd.reverse();
    },
    showModal: {
      get() {
        return this.modalName === 'generalDetailsFile';
      },
      set() {
        this.$store.commit('Dnts/CLEAR_DETAILS');
        this.closeModal();
      }
    },
    authors() {
      return !!this.detailsFile.docDigitalAutores?.length;
    },
    participants() {
      return !!this.detailsFile.docDigitalParticipantes?.length;
    }
  },
  methods: {
    ...mapActions('Dnts', [
      'downloadFilePDF',
      'editConventionDnt',
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('List', [
      'fetchAllDocuments'
    ]),
    async findEmails(subject) {
      this.loadingUsers = true;
      this.$refs.emailsGroup.show();
      const { data: { usuarios } } = await getUsersByGroup({
        empresaId: this.company.id,
        groupId: subject.destinoListaCodigoId,
        cantidad: 0,
        pagina: 1,
        filas: 100000
      });
      this.loadingUsers = false;
      this.usersGroup = usuarios;
    },
    getMatter(data) {
      const matter = (data.find((text) => text.linea === 0) || {}).observacion;
      return matter;
    },
    getObservation(data) {
      const observation = (data.find((text) => text.linea === 1) || {}).observacion;
      return observation;
    },
    getAttachmentsFiles() {
      const files = this.$refs.attachedFiles.getFiles();
      this.additionalFiles = files.additionalFiles.map((file) => ({
        adjuntoId: file.id,
        adjuntoMime: file.mime,
        adjuntoNombre: file.name,
        tipoDescripcion: file.currentDescription,
        adjuntoUrl: file.path,
        fecha: file.date,
        otraReferenciaId: file.trueCopy,
        tipo: 'adjunto'
      })) || [];
      const attachments = [...this.additionalFiles];
      if (Object.keys(files.mainFile).length) {
        this.mainFile = {
          adjuntoId: files.mainFile.id,
          adjuntoMime: files.mainFile.mime,
          adjuntoNombre: files.mainFile.name,
          tipoDescripcion: files.mainFile.currentDescription,
          adjuntoUrl: files.mainFile.path,
          fecha: files.mainFile.date,
          otraReferenciaId: files.mainFile.trueCopy,
          tipo: 'principal'
        };
        attachments.push(this.mainFile);
      }
      return attachments;
    },
    findLabel(document) {
      return this.allDocumentsState.list
        .find((option) => option.value === document) || {};
    },
    validateForm() {
      let valid = true;
      this.error.isPdf = '';
      this.error.noMainFile = '';
      const isPdf = this.mainFile.adjuntoMime === 'application/pdf';
      const isMainFile = Object.keys(this.mainFile).length;

      if (!isPdf && !this.participants) {
        this.error.isPdf = 'El formato del archivo principal debe ser PDF';
        valid = false;
      }
      if (!isMainFile) {
        this.error.noMainFile = 'Falta el archivo principal';
        valid = false;
      }
      return valid;
    },
    async save() {
      const files = this.getAttachmentsFiles();
      const isValid = this.validateForm();
      if (!isValid) return;
      const dnt = JSON.parse(JSON.stringify(this.detailsFile.dnt));
      dnt.estado = '1'; // Creado
      await this.editConventionDnt({
        adjuntos: files,
        detalles: this.detailsFile.detalles,
        dnt,
        destinatarios: this.detailsFile.destinatarios,
        observaciones: this.detailsFile.observaciones,
        etiquetas: this.detailsFile.etiquetas,
        referencias: this.detailsFile.referencias,
        metadata: this.detailsFile.metadata,
        dntDocDigitalAutores: this.detailsFile.docDigitalAutores,
        dntDocDigitalParticipantes: this.detailsFile.docDigitalParticipantes
      });
      this.$bvToast.toast(
        'Los documentos se guardaron correctamente',
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      this.$emit('reload', dnt);
      this.closeModal();
    }
  },
  created() {
    this.fetchAllDocuments();
  }
};
</script>
<style scoped>
.scroll {
  overflow: auto;
  max-height: 650px;
}
.pill-info-attach {
  border: 1px solid #3ca2d6;
  padding: 1px 5px;
  border-radius: 10px;
  font-size: 12px;
  margin-right: 5px;
  cursor:pointer;
}

.box-participants {
  max-height: 300px;
  overflow-y: scroll;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 10px 15px;
  background: rgba(var(--vs-primary), 1) !important;
  color: white !important;
}

.vs-list--item {
  border: none !important;
}
.vs-list--item:last-child {
  border: none !important;
}

.wrap-table {
  max-height: 200px;
  overflow-y: scroll;
}

.wrap-table-large {
  max-height: 300px;
  overflow-y: scroll;
}

.scrollMateria {
  overflow: auto;
  max-height: 100px;
}

.subject-inactive {
  opacity: 0.55;
}
</style>
